import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../@core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class GuestGuard implements CanActivate {
  private auth = inject(AuthService);
  private router = inject(Router);

  async canActivate(): Promise<boolean> {
    await this.auth.waitForAuthReady();

    if (this.auth.isAuthenticated()) {
      this.router.navigate(['/u']);
      return false;
    }

    return true;
  }
}
